import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-live-search',
  templateUrl: './live-search.component.html',
  styleUrls: ['./live-search.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LiveSearchComponent),
      multi: true
    }
  ]
})
export class LiveSearchComponent implements OnInit, ControlValueAccessor {

  @Input() allSearchResults: any;
  @Input() placeHolder: string = "Search";

  searchTerm: string = '';
  filterSearchResults: any = [];

  @Input() maxLength:any = 1000;

  private onChange: any = () => {};
  private onTouched: any = () => {};

  constructor() { }

  ngOnInit() {
    this.filterSearchResults = [];    
  }

  writeValue(value: any): void {
    this.searchTerm = value;
    this.onSearchChange();
    this.filterSearchResults = [];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Implement if you need to handle disabled state
  }

  onSearchChange() {    
    const searchValue = this.searchTerm !== null  ? this.searchTerm.toLowerCase() : "" ;
    if (searchValue) {
      this.filterSearchResults = this.allSearchResults.filter((item: any) =>
        item.toLowerCase().includes(searchValue)
      );

      if(this.filterSearchResults.length === 1 && this.searchTerm.toLowerCase() === this.filterSearchResults[0].toLowerCase()){
        this.filterSearchResults = []
      }
    } else {
      this.filterSearchResults = [];
    }
    this.onChange(this.searchTerm);
    this.onTouched();
  }

  selectItem(item: any) {
    this.searchTerm = item;
    this.filterSearchResults = [];
    this.onChange(this.searchTerm);
    this.onTouched();
  }
}
